// extracted by mini-css-extract-plugin
module.exports = {"facetActions":"NR","done":"OR","disabled":"PR","resetFacets":"QR"};